import html2pdf from "html2pdf.js";

const PDF_EXPORT_CLASS = "fsr-pdf-export-container";
const PDF_EXPORT_ROOT_CLASS = "fsr-pdf-export";

const LIGHT_THEME_VARS = {
    "--app-bg": "#ffffff",
    "--text-color": "#111827",
    "--text-muted": "#64748b",
    "--text-subtle": "#94a3b8",
    "--card-bg": "#ffffff",
    "--card-border": "#e2e8f0",
    "--surface-muted": "#f8fafc",
    "--panel-bg": "#f8fafc",
    "--header-bg": "#eeeeee",
    "--header-border": "#dddddd",
};

function applyLightTheme(el) {
    if (!el || !el.style) return;
    el.setAttribute("data-theme", "light");
    el.style.colorScheme = "light";
    Object.entries(LIGHT_THEME_VARS).forEach(([key, value]) => {
        el.style.setProperty(key, value);
    });
}

/**
 * Export a DOM element to a PDF file. Clones the node into an off-screen
 * container with print-friendly light-mode styles so only the report content
 * is captured (never dark theme).
 */
export async function exportElementToPdf(element, filename) {
    if (!element) {
        throw new Error("Nothing to export");
    }

    const container = document.createElement("div");
    container.className = PDF_EXPORT_CLASS;
    applyLightTheme(container);

    const clone = element.cloneNode(true);
    clone.classList.add(PDF_EXPORT_ROOT_CLASS);
    applyLightTheme(clone);
    container.appendChild(clone);
    document.body.appendChild(container);

    try {
        await html2pdf()
            .set({
                margin: [0.5, 0.5, 0.5, 0.5],
                filename,
                image: { type: "jpeg", quality: 0.95 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    logging: false,
                    backgroundColor: "#ffffff",
                    onclone: (clonedDoc) => {
                        applyLightTheme(clonedDoc.documentElement);
                        applyLightTheme(clonedDoc.body);
                        clonedDoc
                            .querySelectorAll(
                                `.${PDF_EXPORT_CLASS}, .${PDF_EXPORT_ROOT_CLASS}`
                            )
                            .forEach(applyLightTheme);
                    },
                },
                jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
                // avoid-all + break-inside:avoid on tall service cards left empty
                // pages and orphaned "Recorded values" headings. CSS rules handle
                // keeping small units (rows, list items) together instead.
                pagebreak: { mode: ["css", "legacy"] },
            })
            // Export the report clone (has .fsr-pdf-export), not the off-screen
            // wrapper — otherwise position:fixed / left:-10000px would be cloned.
            .from(clone)
            .save();
    } finally {
        document.body.removeChild(container);
    }
}
